module.exports = __webpack_public_path__ + "img/12.55c19ace.png";